import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e5eb1c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heading-4 heading-4 f-roboto fw-light" }, "Archive", -1))
const _hoisted_2 = { style: {"padding":"34px"} }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "box-title" }, "Archive Page", -1))
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "User info goes here.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Settings Tab", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Settings form goes here.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Billing Tab", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Billing info goes here.", -1))
const _hoisted_11 = { class: "parent" }
const _hoisted_12 = {
  key: 0,
  class: "mt-80 mb-50"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_input_header = _resolveComponent("search-input-header")!
  const _component_QuizFilters = _resolveComponent("QuizFilters")!
  const _component_TabsComponent = _resolveComponent("TabsComponent")!
  const _component_archive_card = _resolveComponent("archive-card")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { onOnSearchBarSubmit: _ctx.handleSearch }, {
    "header-left": _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createVNode(_component_search_input_header, {
                value: _ctx.searchValue,
                onHandleSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSearch($event)))
              }, null, 8, ["value"])
            ]),
            _createVNode(_component_QuizFilters, { onOnFilterChange: _ctx.onFilterChange }, null, 8, ["onOnFilterChange"])
          ])
        ]),
        _createVNode(_component_TabsComponent, {
          tabs: _ctx.tabs,
          selectedValue: _ctx.tabName,
          onChange: _ctx.onTabChange
        }, {
          profile: _withCtx(() => [
            _hoisted_6
          ]),
          settings: _withCtx(() => [
            _hoisted_7,
            _hoisted_8
          ]),
          billing: _withCtx(() => [
            _hoisted_9,
            _hoisted_10
          ]),
          _: 1
        }, 8, ["tabs", "selectedValue", "onChange"]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
            return (_openBlock(), _createElementBlock("div", {
              key: document.id,
              class: "child"
            }, [
              _createVNode(_component_archive_card, {
                id: document.id,
                name: document.name,
                "gradient-type": document.color,
                "last-edited": document.updated_at,
                progress: document.answers_progress / 100,
                "filter-values": document.filter_values,
                "business-function-id": _ctx.businessFunctionId,
                onOnUnarchive: _ctx.unarchiveQuiz,
                document: document
              }, null, 8, ["id", "name", "gradient-type", "last-edited", "progress", "filter-values", "business-function-id", "onOnUnarchive", "document"])
            ]))
          }), 128))
        ]),
        (_ctx.haveItems)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_ctx.pageMeta.current_page)
                ? (_openBlock(), _createBlock(_component_pagination, {
                    key: 0,
                    "current-page": _ctx.pageMeta.current_page,
                    "total-pages": _ctx.pageMeta.total,
                    meta: _ctx.pageMeta,
                    onHandleClick: _ctx.navigateToPage
                  }, null, 8, ["current-page", "total-pages", "meta", "onHandleClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onOnSearchBarSubmit"]))
}